import { DraftDesignConfiguration, ProductType } from '@/types';
import { getRestrictions } from '@/utils/embroideryRestrictions';
import { getMaxScaleForConfiguration } from './getMaxScale';

export function isRestrictedScaleBelowMinimumScale(
  configuration: DraftDesignConfiguration,
  productType: ProductType,
  printAreaId: string
) {
  const restriction = getRestrictions(productType, printAreaId);
  const restrictedMaxScale = getMaxScaleForConfiguration(configuration, restriction);
  return restrictedMaxScale < configuration.design.restrictions.minimumScale / 100;
}
